import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import PlatformLayout from 'layout/PlatformLayout';
import jwt from 'jwtservice/jwtService';

const PlatformLogin = Loadable(lazy(() => import('views/platform-admin/PlatformLogin')));
const Dashboard     = Loadable(lazy(() => import('views/platform-admin/Dashboard')));
const AllTenants    = Loadable(lazy(() => import('views/platform-admin/AllTenants')));
const AddTenant     = Loadable(lazy(() => import('views/platform-admin/AddTenant')));
const ManageTenant  = Loadable(lazy(() => import('views/platform-admin/ManageTenant')));
const Plans         = Loadable(lazy(() => import('views/platform-admin/Plans')));
const CreatePlan    = Loadable(lazy(() => import('views/platform-admin/CreatePlan')));
const ManagePlan    = Loadable(lazy(() => import('views/platform-admin/ManagePlan')));

const platformLoginGuard = (el) =>
    jwt.getIsLogin() && jwt.isPlatformAdmin()
        ? <Navigate to="/platform/dashboard" replace />
        : el;

const platformGuard = (el) => {
    if (!jwt.getIsLogin()) return <Navigate to="/platform/login" replace />;
    if (!jwt.isPlatformAdmin()) return <Navigate to="/login" replace />;
    return el;
};

const PlatformRoutes = {
    path: '/platform',
    element: <PlatformLayout />,
    children: [
        { path: '/platform/login',          element: platformLoginGuard(<PlatformLogin />) },
        { path: '/platform/dashboard',      element: platformGuard(<Dashboard />) },
        { path: '/platform/tenants',        element: platformGuard(<AllTenants />) },
        { path: '/platform/create-tenant',  element: platformGuard(<AddTenant />) },
        { path: '/platform/manage-tenant',  element: platformGuard(<ManageTenant />) },
        { path: '/platform/plans',          element: platformGuard(<Plans />) },
        { path: '/platform/create-plan',    element: platformGuard(<CreatePlan />) },
        { path: '/platform/manage-plan',    element: platformGuard(<ManagePlan />) },
    ],
};

export default PlatformRoutes;
